module.exports = __webpack_public_path__ + "static/Banner carrousel home Enero-02-44245939205e55d0ea4574bec07f8ff5.jpg";